module.exports = __webpack_public_path__ + "img/12.7fe3fe07.png";